import { Navigate, useSearchParams } from "react-router-dom";
import { useSession } from "../session";

const MESSAGES: Record<string, string> = {
  wrong_domain: "That account is not on the howtoweb.co domain.",
  cancelled: "Sign-in was cancelled.",
  state_mismatch: "The sign-in link expired. Please try again.",
  token_exchange_failed: "Google rejected the sign-in. Please try again.",
  unverified_email: "That Google account has no verified email address.",
  bad_audience: "This deployment's Google client ID does not match.",
  bad_issuer: "The identity token did not come from Google.",
  expired: "The sign-in token had already expired.",
  no_identity: "Google returned no identity for that account.",
  bad_request: "Something went wrong starting the sign-in.",
};

export default function LoginPage() {
  const [params] = useSearchParams();
  const { user, loading } = useSession();

  const next = params.get("next") || "/";
  const error = params.get("error");

  if (loading) return null;
  if (user) return <Navigate to={next} replace />;

  return (
    <div className="login">
      <div className="login-card">
        <h1>Handbook</h1>
        <p>Internal to How To Web. Sign in with your howtoweb.co Google account.</p>

        {error && <div className="login-error">{MESSAGES[error] ?? "Sign-in failed."}</div>}

        <a className="btn btn-primary" href={`/auth/login?next=${encodeURIComponent(next)}`}>
          Continue with Google
        </a>
      </div>
    </div>
  );
}
